import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ApplicationsList from '../../components/Leave/Applications'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v4_change_leave_application_staus, v4_leave_applications } from '../../actions/v4/leave'
import { replacePageState } from '../../utils';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [refresh, setRefresh] = useState(false)


    useEffect(() => {
        v4_leave_applications(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.leaveApplications.url, {
                    page: currentPage // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit, refresh])

    const changeApplicationStatus = (leaveId, status, remark = '') => {
        v4_change_leave_application_staus({ status, remark }, leaveId).then((res) => {
            if (res.status) {
                toast.success(res.result?.message || 'Status updated successfully');
                // Refresh data after status change
                setRefresh(!refresh)
            } else {
                toast.error(res.error || 'Failed to update status');
            }
        }).catch((err) => {
            toast.error('Error occurred while changing status');
        });
    };

    return (
        <Layout
            title={'Leave Applications'}
        >
            {data && <ApplicationsList
                limit={limit}
                data={data}
                changeApplicationStatus={changeApplicationStatus}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />}
        </Layout>
    )
}

export default List